import { Slide } from "@jelly/lesson";

import { task as task02 } from "../../../../../task/course-04/lesson-28/task-02";

const task: Slide = {
  titleHtml:
    "A linear array made of 10 speakers equally spaced from 10 cm and driven<br>with the same signal exhibit aliaising for frequencies higher than:",
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task02.id,
        },
      },
    },
  },
};

export default task;
